import React from 'react'
import { MainContainer } from './SearchStyles'
import SearchResults from '../../components/Search/SearchResults'


const Search = () => {
    return (
        <MainContainer>
            <SearchResults />
        </MainContainer>
    )
}

export default Search
